module.exports = __webpack_public_path__ + "static/media/Avatars_Female-16.606992bb.png";